import moment from 'moment';

const currentLanguage = moment.locale();

export default currentLanguage;
